var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-220.9,382.7c-0.5-0.1-1.1-0.1-1.5,0.1c-5.4,2.1-8.8,9.8-9.6,15.1c-2.5,17.2,11.1,32.1,23.6,41.9c11.1,8.7,32.4,23,45,9.2  c1.6-1.7,3.5-4.2,3.4-6.7c-0.3-4.2-4.2-7.2-7.2-9.5c-2.3-1.7-7.1-6.4-10.1-6.3c-2.7,0.1-4.4,2.9-6.1,4.6l-3,3  c-0.5,0.5-6.9-3.7-7.6-4.2c-2.6-1.7-5.1-3.6-7.3-5.7c-2.2-2.1-4.2-4.4-5.9-6.8c-0.5-0.7-4.6-6.8-4.2-7.3c0,0,3.5-3.8,4.5-5.3  c2.1-3.2,3.7-5.7,1.3-9.5c-0.9-1.4-2-2.5-3.2-3.7c-2.1-2-4.2-4.1-6.6-5.8C-216.7,384.8-218.9,383-220.9,382.7z"}));
}

Phone.defaultProps = {"version":"1.1","width":"28","viewBox":"-247 370.9 100 100","fill":"#174aa5"};

module.exports = Phone;

Phone.default = Phone;
